import {ContentType, HttpMethod, HttpService} from "./HttpService";

export interface SubscribeNewsletterRequest {
    email: string,
    type: string,
    name?: string,
    source?: string
    variation?: string
    eventUrl?: string
    webinarDate?: string
    experimentId?: string
    sessionId?: string
    webinarVariation?: string
    eventId?: string
    phoneNumber?: string
    language?: 'pl' | 'en'
    timezone?: string
    captchaToken?: string
}

export interface SubscribeNewsletterResponse {
    email?: string
    message?: string
    webinarId?: string
}

export interface CancelNewsletterRequest {
    email: string,
    type: string,
    reason?: string,
    newsletterId?: string,
    followUpName?: string
}

export class NewsletterService {
    public static subscribeNewsletter(requestBody: SubscribeNewsletterRequest): Promise<SubscribeNewsletterResponse> {
        return HttpService.sendRequest<SubscribeNewsletterResponse>(
            HttpMethod.POST,
            '/api/newsletter/add',
            JSON.stringify(requestBody),
            ContentType.JSON
        );
    }

    public static cancelNewsletter(requestBody: CancelNewsletterRequest): Promise<void> {
        return HttpService.sendRequest<void>(
            HttpMethod.POST,
            '/api/newsletter/remove',
            JSON.stringify(requestBody),
            ContentType.JSON
        );
    }
}
